import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from "@mui/material";
import { restPath, prefix } from "./../App";

const CancelSubscriptionBtn = ({ setUserInfo, userInfo, setDone, setIsLoading, isLoading }) => {
  const { id, expiry, email, orderId } = userInfo;
  const [open, setOpen] = useState(false);

  console.log(userInfo)

  const name = userInfo.middleName
    ? `${userInfo.familyName} ${userInfo.middleName} ${userInfo.firstName}`
    : `${userInfo.familyName} ${userInfo.firstName}`;

  const nameEn = userInfo.middleNameEn
    ? `${userInfo.firstNameEn} ${userInfo.middleNameEn} ${userInfo.familyNameEn}`
    : `${userInfo.firstNameEn} ${userInfo.familyNameEn}`;

  const handleCancel = () => {
    if (!orderId) {
      console.error("❌ No subscription ID found.");
      setDone("failed");
      return;
    }

    setIsLoading(true);

    const payload = {
      userId: id,
      orderId: orderId,
      email: email,
      name: name,
      nameEn: nameEn,
      expiry: expiry,
    };

    console.log("📦 Cancel payload:", payload);

    fetch(`${restPath}/wp-json/${prefix}yearlyplan/v1/cancel`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("✅ キャンセル完了:", data);
        const updatedUserInfo = {
          ...userInfo,
          paypalStatus: "CANCELLED",
          paymentMethod: "end_paypal_subscription",
          membership: "individual",
        };
        setUserInfo(updatedUserInfo);
        sessionStorage.setItem("jacUserCore", JSON.stringify(updatedUserInfo));
        setDone("success");
      })
      .catch((err) => {
        console.error("❌ キャンセル失敗:", err);
        setDone("failed");
      })
      .finally(() => {
        setIsLoading(false);
        setOpen(false); // モーダルを閉じる
      });
  };

  return (
    <div style={{ textAlign: "center", marginTop: "32px" }}>
      <Button
        variant="contained"
        color="error"
        onClick={() => setOpen(true)}
        sx={{
          background: `var(--red)`,
          fontSize: `18px`,
          textTransform: "none",
        }}
      >
        年間サブスクを解約する
      </Button>

      <Dialog
        open={open}
        onClose={isLoading ? undefined : () => setOpen(false)}
      >
        <DialogTitle>年間サブスクリプションの解約確認</DialogTitle>
        <DialogContent>
          <Typography sx={{ mt: 2 }}>
            本当に年間サブスクリプションを解約しますか？<br />
            解約すると次回以降の請求は停止されます。
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary" disabled={isLoading}>
            キャンセル
          </Button>
          <Button onClick={handleCancel} color="error" variant="contained" disabled={isLoading}>
            解約する
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CancelSubscriptionBtn;
